import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BotonTipo } from '../../../../components/boton/boton';
import { Caracteristica } from '../../../../interfaces/caracteristica';
import { CaracteristicaService } from '../../../../providers/caracteristica.service';

@Component({
  selector: 'app-orden-caracteristica',
  templateUrl: './orden-caracteristica.component.html',
  styleUrls: ['./orden-caracteristica.component.scss']
})
export class OrdenCaracteristicaComponent implements OnInit {
  @Input() type: BotonTipo;
  @Input() caracteristica?: Caracteristica;
  @Input() tooltipDir: string = 'below';
  @Input() disabled: boolean = false;
  @Input() direccion: "subir" | "bajar";
  @Output() onCambiado = new EventEmitter();
  @Output() onCargando = new EventEmitter();
  cargando: boolean = true;

  constructor(
    private caracteristicaService: CaracteristicaService
  ) { }

  ngOnInit() {
    if (!this.type) {
      throw "La variable Input 'type' es requerida";
    }
    if (!this.caracteristica) {
      throw "La variable Input 'caracteristica' es requerida";
    }
    if (!this.direccion) {
      throw "La variable Input 'direccion' es requerida";
    }
  }

  cambiarOrden(direccion: "subir" | "bajar") {
    this.cargando = true;
    this.onCargando.emit(true);
    this.caracteristicaService
      .ordenCaracteristica(direccion, this.caracteristica.IdCaracteristica)
      .subscribe(
        (respuesta) => {
          if (respuesta && respuesta.estado == 1) {
            this.onCambiado.emit(this.caracteristica.IdCaracteristica);
          }
          this.cargando = false;
          this.onCargando.emit(false);
        },
        () => {
          this.cargando = false;
          this.onCargando.emit(false);
        }
      );
  }
}
